import {
	mutationPermissionRequirements,
	type PermissionedMutation,
} from "@/constants/permissions/permissions";

/**
 * Pure check: does the given permissions array satisfy every requirement
 * for `mutation`?
 *
 * Note: for InvestingEntity, `permissions` is only populated on the active
 * investing entity in GraphQL responses, so callers must pass the active
 * entity's `permissions` array (or read it from a mutation response that
 * specifically selects `permissions` on the new active entity).
 */
export function entityHasMutationPermission(
	permissions: readonly string[] | null | undefined,
	mutation: PermissionedMutation,
): boolean {
	const required = mutationPermissionRequirements[mutation].map(
		({ requires }) => requires,
	);
	const granted = permissions ?? [];
	return required.every((p) => granted.includes(p));
}
